/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import t from"./PointCloudBitfieldFilter.js";import o from"./PointCloudFilter.js";import i from"./PointCloudReturnFilter.js";import r from"./PointCloudValueFilter.js";const e={key:"type",base:o,typeMap:{value:r,bitfield:t,return:i}};export{e as types};
